<script setup lang="ts">
import { MenubarContent, type MenubarContentProps, MenubarPortal } from "radix-vue";

const props = withDefaults(defineProps<MenubarContentProps>(), {
	align: "start",
	alignOffset: -4,
	sideOffset: 8,
});
</script>

<template>
	<MenubarPortal>
		<MenubarContent
			v-bind="props"
			class="z-50 min-w-48 overflow-hidden rounded-md border bg-overlay p-1 text-on-overlay shadow-md data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95"
			:class="$attrs.class"
		>
			<slot />
		</MenubarContent>
	</MenubarPortal>
</template>
